
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tepezza/contact-us",
      function () {
        return require("private-next-pages/tepezza/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tepezza/contact-us"])
      });
    }
  